// lib/dateiHolen.js — PDF/CSV/SVG vom Server mit Anmeldung holen (18.10.2026)
//
// Ein Link (<a href>) schickt das Token nicht mit, deshalb hier per fetch und
// als Blob. `fetch` wirft bei 4xx nicht: res.ok wird geprüft, die Fehlermeldung
// des Servers kommt als Error zurück, damit die Seite sie zeigen kann.
//
//   await dateiHolen('/api/nachbereitung/1/urkunden/pdf', { oeffnen: true });
//   await dateiHolen('/api/nachbereitung/1/abrechnung/csv', { dateiname: 'abrechnung.csv' });

export async function dateiHolen(url, { oeffnen = false, dateiname = null } = {}) {
  // Fenster sofort öffnen (im Klick), sonst blockt der Browser das Popup.
  const fenster = oeffnen ? window.open('', '_blank') : null;
  try {
    const r = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
    if (!r.ok) {
      const d = await r.json().catch(() => ({}));
      throw new Error(d.error || `HTTP ${r.status}`);
    }
    const blob = await r.blob();
    const blobUrl = URL.createObjectURL(blob);
    if (fenster) {
      fenster.location.href = blobUrl;
    } else {
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = dateiname || 'datei';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    return true;
  } catch (e) {
    if (fenster) fenster.close();
    throw e;
  }
}
